import { IDefineCommand, IQueryMediator } from 'core-ts-types';
import { PreferencesSelectionModel } from '../../../term_courses/models/preferences_selection_model';
import * as _4 from 'lodash4';
angular
  .module('capability-ng-scheduler')
  .service(
    'loadTermLocationPreferencesCommand',
    function loadTermLocationPreferencesCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngPreferencesSelectionModel: PreferencesSelectionModel,
      CampusLocationBuilder: any,
      log: any
    ) {
      'use strict';

      return defineCommand(
        'loadTermLocationPreferencesCommand',
        function loadTermLocationPreferencesCommand(deferred, termId) {
          $http.get('/cat/student/term/' + termId + '/campus/').then(
            (response: { data: { prefs_first_visit: boolean } }) => {
              const isPreferencesFirstVisit: boolean = _4.get(response.data, 'prefs_first_visit', false);
              ngPreferencesSelectionModel.clear().write(isPreferencesFirstVisit);
              deferred.resolve(new CampusLocationBuilder(response.data));
            },
            (response) => {
              log.issue('failed to load term location preferences');
              deferred.reject(response.data);
            }
          );
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/commands/load_term_location_preferences_command.ts